export default "__VITE_ASSET__B46mn0T0__"